import {
    AbstractControl,
    ValidationErrors,
    FormGroup,
    ValidatorFn
} from '@angular/forms';
import { NgbTime } from '@ng-bootstrap/ng-bootstrap/timepicker/ngb-time';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class GenericValidator {
    constructor() { }

    static mustMatch(matchingControlName: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const parent = control.parent;
            if (parent) {
                const matchingControl = parent.controls[matchingControlName];
                if (control.errors && !control.errors.mustMatch) {
                    return;
                }

                if (control.value !== matchingControl.value) {
                    return { mustMatch: true };
                }
            }
            return null;
        };
    }

    static minDate(minDate: NgbDate): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const date = control.value;
            if (date) {
                if (minDate.before(date) && minDate.equals(date)) {
                    return;
                }

                if (minDate.after(date)) {
                    return { minDate: true };
                }
            }
            return null;
        };
    }

    static minTime(minTime: any): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const time = control.value;
            if (time) {
                if (minTime.hour <= time.hour) {
                    return;
                }

                if (minTime.hour > time.hour) {
                    return { minTime: true };
                }
            }
            return null;
        };
    }

    static isAdult(control: AbstractControl): ValidationErrors {
        const birth = control.value;
        if (birth) {
            if (birth.singleDate) {
                if (birth.singleDate.formatted) {
                    const [day, month, year] = birth.singleDate.formatted.split(
                        '/'
                    );
                    const today = new Date();
                    const birthDate = new Date(year, month, day, 0, 0, 0);
                    const adultTime = 1000 * 60 * 60 * 24 * 365 * 18;

                    if (today.getTime() - birthDate.getTime() >= adultTime) {
                        return;
                    } else {
                        return { isAdult: true };
                    }
                }
            }
        }
    }

    static minimumAge(minAge: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            const birth = control.value;
            if (birth) {
                if (birth.singleDate) {
                    if (birth.singleDate.formatted) {
                        const [day, month, year] = birth.singleDate.formatted.split(
                            '/'
                        );
                        const today = new Date();
                        const birthDate = new Date(year, month - 1, day, 0, 0, 0);
                        const adultTime = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());

                        if (birthDate.getTime() <= adultTime.getTime()) {
                            return;
                        } else {
                            return { minimumAge: true };
                        }
                    }
                }
            }
        };
    }

    static maximumAge(maxAge: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            const birth = control.value;
            if (birth) {
                if (birth.singleDate) {
                    if (birth.singleDate.formatted) {
                        const [day, month, year] = birth.singleDate.formatted.split(
                            '/'
                        );
                        const today = new Date();
                        const birthDate = new Date(year, month - 1, day, 0, 0, 0);
                        const maxDate = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());

                        if (birthDate.getTime() >= maxDate.getTime()) {
                            return;
                        } else {
                            return { maximumAge: true };
                        }
                    }
                }
            }
        };
    }


    static lockDate(control: AbstractControl): ValidationErrors {
        const date = control.value;
        if (date) {
            if (date.singleDate) {
                if (date.singleDate.formatted) {
                    const [day, month, year] = date.singleDate.formatted.split(
                        '/'
                    );
                    const today = new Date();
                    const birthDate = new Date(year, month, day, 0, 0, 0);
                    const lockTime = 1000 * 60 * 60 * 24 * 365 * 100;

                    if (today.getTime() - birthDate.getTime() < lockTime) {
                        return;
                    } else {
                        return { lockDate: true };
                    }
                }
            }
        }
    }

    static validDataNascimento(control: AbstractControl): ValidationErrors {
        const birth = control.value;
        if (birth && birth.formatted) {
            const [day, month, year] = birth.formatted.split('/');
            const today = new Date();
            const birthDate = new Date(year, month, day, 0, 0, 0);
            const validDataNascimento = 1000 * 60 * 60 * 24 * 365 * 14;
            if (today.getTime() - birthDate.getTime() >= validDataNascimento) {
                return;
            } else {
                return { isDataNascimento: true };
            }
        }
    }

    static isCellPhone(control: AbstractControl): ValidationErrors {
        const cellphone = control.value.replace(/\D+/g, '').replace(' ', '');
        if (cellphone[2] === '9') {
            return;
        } else {
            return { isCellPhone: true };
        }
    }

    static isLandlinePhone(control: AbstractControl): ValidationErrors {
        const cellphone = control.value.replace(/\D+/g, '').replace(' ', '');
        if (cellphone[2] !== '9') {
            return;
        } else {
            return { isLandlinePhone: true };
        }
    }

    // Verifica validação dos campos
    static verifierValidatorsForm(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(campoControls => {
            const control = formGroup.get(campoControls);
            control.markAsDirty();
            control.markAsTouched();
            if (control instanceof FormGroup) {
                this.verifierValidatorsForm(control);
            }
        });
    }
}
